<template>

	<div class="report_container full" v-loading="loading">
		<vxe-grid :id="reportName+'_list'" class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	export default {
		mixins: [reportBase],
		name: 'report',
		props: {

		},
		data() {
			return {
				// footerField: [{
				// 	type: 'seq',
				// 	field: 'code',
				// 	title: '汇总',
				// }, {
				// 	type: 'field',
				// 	field: 'num',
				// 	toFixed: 1
				// }, {
				// 	type: 'field',
				// 	field: 'preamount',
				// 	toFixed: 4
				// }, {
				// 	type: 'field',
				// 	field: 'amount',
				// 	toFixed: 4
				// }],
				reportName: 'crmcustomer',
				windowName: '客户订单明细',
				showFooter: false,
				exportRef: Math.random(),
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
